'use strict';
module.exports = require('./lib/index');



//////////////////
// WEBPACK FOOTER
// ./~/shortid/index.js
// module id = 451
// module chunks = 4 6 7 8 9 10 12 19 21 22 24 27 55 56